import { useRef } from "react";

export function useUrlParams() {
  const processedCodes = useRef(new Set<string>());
  const isProcessing = useRef(false);

  const checkAuthParams = (): {
    ta: string | null;
    h: string | null;
    code: string | null;
  } => {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      ta: urlParams.get("ta"),
      h: urlParams.get("h"),
      code: urlParams.get("code"),
    };
  };

  const markCodeAsProcessed = (code: string) => {
    processedCodes.current.add(code);
  };

  const isCodeProcessed = (code: string) => {
    return processedCodes.current.has(code);
  };

  const setProcessing = (processing: boolean) => {
    isProcessing.current = processing;
  };

  const isProcessingState = () => {
    return isProcessing.current;
  };

  const removeCode = (code: string) => {
    processedCodes.current.delete(code);
  };

  return {
    checkAuthParams,
    markCodeAsProcessed,
    isCodeProcessed,
    setProcessing,
    isProcessingState,
    removeCode,
  };
}
